import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import {
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    Card,
    Collapse,
    IconButton,
    Slider,
    Stack,
    Paper
} from "@mui/material";
// import Grid from "@mui/material/Grid2";
// import { toast, Bounce } from "react-toastify";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
// import { useTheme } from '@mui/material/styles';
// import { areaElementClasses } from '@mui/x-charts/LineChart';
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { formatIndianCurrency, formatIndianCurrencyCompact, formatPercentage } from '../utils/currency';

const DeploymentHistory = ({ data }) => {

    const tableColumns = [
        // { field: "id", headerName: "ID", width: 70 },
        {
            field: 'updated_at',
            headerName: 'Timestamp',
            // description: 'This column has a value getter and is not sortable.',
            // sortable: false,
            width: 100,
            valueGetter: (value, row) => `${moment(row.updated_at).format("hh:mm:ss")}`,
        },
        { field: "status", headerName: "Status", width: 200 },
        { field: "pnl", headerName: "PnL", width: 100 },
        { field: "other_charges", headerName: "Charges", width: 100 },
        { field: "net_pnl", headerName: "Net PnL", width: 100 },
        { field: "funds_balance", headerName: "Funds Balance", width: 100 },
        { field: "current_stop_loss", headerName: "Stop Loss", width: 100 },
    ];

    // Utility function to format snake_case keys
    const formatKey = (key) => {
        return key
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    };

    // var statsRows = [];
    // Object.entries(data).map(([key, value]) => {
    //     statsRows.push({ key: formatKey(key), value: value?.toFixed(2).toLocaleString() });
    // });

    // Utility function to format currency (keeping for backward compatibility)
    function formatPrice(value) {
        return formatIndianCurrency(value);
    }

    // Utility function to format currency with compact notation
    function formatCurrency(value) {
        return formatIndianCurrencyCompact(value);
    }

    // Utility function to format percentage (unsigned)
    function formatPercentageUnsigned(value) {
        return formatPercentage(value, false);
    }

    // Utility function to format currency
    function getFontColor(value) {
        const isNegative = value < 0;
        return isNegative ? `#D32F2F` : `#4CAA50`;
    }

    const paginationModel = { page: 0, pageSize: 10 };

    return (
        <Card sx={{
            // display: { xs: 'none', md: 'block' },
            backgroundColor: 'background.paper',
            p: 2
        }}>

            <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                History
            </Typography>
            <Paper sx={{ width: "100%" }}>
                <DataGrid rowSelection={false} rows={data} columns={tableColumns} initialState={{ pagination: { paginationModel } }} pageSizeOptions={[5, 10]} checkboxSelection sx={{ border: 0 }} />
            </Paper>
        </Card >
    );
};

export default DeploymentHistory;
